/* Publish by EComposer at 2026-11-03 17:08:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-d3cvq8tqg55"]=  window.__ectimmers["ecom-d3cvq8tqg55"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-d3cvq8tqg55').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-d3cvq8tqg55', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-d3cvq8tqg55', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zj1sc8omcf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zj1sc8omcf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zj1sc8omcf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6zhbcfrjhjx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6zhbcfrjhjx', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6zhbcfrjhjx', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fdnf0m05ek').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fdnf0m05ek', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fdnf0m05ek', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-pfoc13hh54f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pfoc13hh54f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pfoc13hh54f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2q1q6ue39r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2q1q6ue39r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2q1q6ue39r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wahlgc0cwzk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wahlgc0cwzk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wahlgc0cwzk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-pb49m8rlvam').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pb49m8rlvam', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pb49m8rlvam', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6w1ezi74kh8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6w1ezi74kh8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6w1ezi74kh8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-z2oqk1l11an').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-z2oqk1l11an', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-z2oqk1l11an', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-d7jzj580iut').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-d7jzj580iut', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-d7jzj580iut', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-n4y9tz5lzok').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-n4y9tz5lzok', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-n4y9tz5lzok', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kiuhzvx4v4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kiuhzvx4v4', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kiuhzvx4v4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fp4uzm3xq4l').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fp4uzm3xq4l', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fp4uzm3xq4l', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0y73ifxj9m3').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0y73ifxj9m3', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0y73ifxj9m3', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0n7uug6mwxmf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0n7uug6mwxmf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0n7uug6mwxmf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-lf7t9zje1gr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-lf7t9zje1gr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-lf7t9zje1gr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-obluwmtexu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-obluwmtexu', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-obluwmtexu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-tzl3uj7epdo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-tzl3uj7epdo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-tzl3uj7epdo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-bocp4u5trwg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-bocp4u5trwg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-bocp4u5trwg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nezlvk9xwos').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nezlvk9xwos', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nezlvk9xwos', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-w74n7z62ai').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-w74n7z62ai', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-w74n7z62ai', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ablzro6zeb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ablzro6zeb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ablzro6zeb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7vge8234yl2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7vge8234yl2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7vge8234yl2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u6n1sy2uqma').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u6n1sy2uqma', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u6n1sy2uqma', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3mg22h7znj3').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3mg22h7znj3', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3mg22h7znj3', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4dsapq4ipiq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4dsapq4ipiq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4dsapq4ipiq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-95kbt2n1tft').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-95kbt2n1tft', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-95kbt2n1tft', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ofkrczf9sob').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ofkrczf9sob', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ofkrczf9sob', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v08pdxqxnpj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v08pdxqxnpj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v08pdxqxnpj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-mx9uecjubvd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-mx9uecjubvd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-mx9uecjubvd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-01jolqppcep5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-01jolqppcep5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-01jolqppcep5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4myrsv9ubwj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4myrsv9ubwj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4myrsv9ubwj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gus7pkh6l0q').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gus7pkh6l0q', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gus7pkh6l0q', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-czxvg8mphf6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-czxvg8mphf6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-czxvg8mphf6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kd209previ').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kd209previ', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kd209previ', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-pxfr58j6k8n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pxfr58j6k8n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pxfr58j6k8n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-litol9wwjum').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-litol9wwjum', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-litol9wwjum', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yhrl1uswh0p').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yhrl1uswh0p', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yhrl1uswh0p', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3849zqh4zup').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3849zqh4zup', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3849zqh4zup', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qbpdwldn3ql').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qbpdwldn3ql', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qbpdwldn3ql', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-lnqwlgd3uri').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-lnqwlgd3uri', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-lnqwlgd3uri', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-tp4t8pgwyg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-tp4t8pgwyg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-tp4t8pgwyg', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a7isv4sw9sq"]=  window.__ectimmers["ecom-a7isv4sw9sq"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-a7isv4sw9sq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a7isv4sw9sq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a7isv4sw9sq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-w6tb4aagmd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-w6tb4aagmd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-w6tb4aagmd', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8f2ja9vc9sf"]=  window.__ectimmers["ecom-8f2ja9vc9sf"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-8f2ja9vc9sf"]["2kltbo51q"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-8f2ja9vc9sf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8f2ja9vc9sf', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8f2ja9vc9sf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jq181zod3lc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jq181zod3lc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jq181zod3lc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yfpemb0fo8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yfpemb0fo8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yfpemb0fo8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u32by0jfw7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u32by0jfw7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u32by0jfw7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9eha317gkhf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9eha317gkhf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9eha317gkhf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7o9vtwnakh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7o9vtwnakh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7o9vtwnakh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9hs9r08i7l8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9hs9r08i7l8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9hs9r08i7l8', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vzwv8z22sfd"]=  window.__ectimmers["ecom-vzwv8z22sfd"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-vzwv8z22sfd"]["g1s1fvrvr"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-vzwv8z22sfd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vzwv8z22sfd', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vzwv8z22sfd', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-04eycc8ns39j"]=  window.__ectimmers["ecom-04eycc8ns39j"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-04eycc8ns39j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-04eycc8ns39j', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-04eycc8ns39j', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u0wh81zygd8"]=  window.__ectimmers["ecom-u0wh81zygd8"] || {};
if(!this.$el)return!1;const t=this.$el;let e=t.closest(".ecom-product-form--single");if(!e){const n=t.closest(".ecom-builder");n&&(e=n.querySelector(".ecom-product-form--single"))}if(!e)return!1;if(this.isLive){let n=e.querySelector("[name=id]");const s=(n?parseInt(n.getAttribute("ec-variants")):0)>250||e.querySelector("[data-high-variant-product]"),r=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout"),a=e.dataset.product_id;if(!a)return;let l=null;const c=e.querySelector("[id^=product-json-"+a+"]");if(!c)return;try{l=JSON.parse(c.innerHTML)}catch(d){return}r&&r.addEventListener("click",function(d){d.preventDefault();let p=1;e.querySelector("[name=quantity]")&&(p=e.querySelector("[name=quantity]").value);let m=e.querySelector("select[name=id]")||e.querySelector("input[name=id]");m||console.warn("EC error: Select id or input id not found!");let _=m.value,b=null;if(s?b=l:b=l.variants.find(v=>v.id==_),!b||b.available===!1)return;window.Shopify.analytics&&Shopify.analytics.publish("ec_buy_now",{cartLine:{cost:{totalAmount:{amount:b.price*p,currencyCode:window.Shopify.currency.active}},merchandise:{id:b.id,image:b.image,price:{amount:b.price,currencyCode:window.Shopify.currency.active},product:{id:l.id,title:l.title,vendor:l.vendor},sku:b.sku,title:b.title},quantity:p}});let y=`${window.EComposer.routes.cart_url}/${_}:${p}`;if(window.location.search.includes("selling_plan")){const v=/selling_plan=(\d+)/,w=window.location.search.match(v);if(w){const S=w[1];y=`${window.EComposer.routes.cart_url}/clear?return_to=/cart/add?items[][id]=${_}%26items[][quantity]=${p}%26items[][selling_plan]=${S}%26return_to=/checkout`}}location.href=y}),l.available||(r.classList.add("ecom-disable-buy"),r.disabled=!0),n&&e.addEventListener("ecomVariantChange",function(d){let p=d.detail.variant;!p||p.available===!1?(r.classList.add("ecom-disable-buy"),r.disabled=!0):(r.classList.remove("ecom-disable-buy"),r.disabled=!1)})}const i=function(n){if(!t)return;const o=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout");if(!o)return;let s=parseInt(n.settings.animation_loop_time)*1e3||6e3,r=1e3;window.__ectimmers["ecom-u0wh81zygd8"]["ecyg0alow"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},r)},s)};this.settings.animation&&i(this)

                    });
                    
                        document.querySelectorAll('.ecom-u0wh81zygd8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u0wh81zygd8', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u0wh81zygd8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6vfdf7zku2g').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6vfdf7zku2g', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6vfdf7zku2g', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}